import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

import Loader from '@justgiving/loading/es/Loading';
import { Button, TrackingData } from '@justgiving/react-tracking';
import { ClickTrackingData } from '@justgiving/react-tracking/es/Button';

const LoadMoreButton: FunctionComponent<LoadMoreButton> = ({
  loading,
  children,
  onClick,
  trackingData,
  className,
  trackingIdentifier,
}) => {
  const [loadingFeedback, setLoadingFeedback] = useState(false);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (loading) {
      timer.current = window.setTimeout(() => {
        setLoadingFeedback(true);
      }, 250);
    } else {
      setLoadingFeedback(false);
    }
    return () => {
      clearInterval(timer.current);
    };
  }, [loading]);

  return (
    <Button
      className={`jg-btn jg-btn--ghost ${className || ''}`}
      onClick={onClick}
      type="button"
      disabled={loading}
      trackingData={trackingData}
      data-qa="load-more"
      data-track={trackingIdentifier}
    >
      {loading && loadingFeedback ? <Loader size="small" /> : children}
    </Button>
  );
};

interface LoadMoreButton {
  onClick: () => void;
  loading: boolean;
  trackingData: ClickTrackingData & TrackingData;
  className?: string;
  trackingIdentifier?: string;
}

export default LoadMoreButton;
